
import translateConfig from './stepway.translate';

const TRANSLATE_MODULE = 'eda.easyFormGenerator.translate';

export default angular
                .module(TRANSLATE_MODULE, [])
                .config(translateConfig);



// WEBPACK FOOTER //
// ./src/app/stepway/config/translate/stepway.translate.module.js